import { prefersReducedMotion } from "./reveal-motion";

export type CanvasViewportTransitionOptions = {
  duration?: number;
  ease?: (t: number) => number;
  interpolate?: "smooth" | "linear";
};

export const CANVAS_VIEWPORT_TRANSITION_MS = {
  zoom: 240,
  focusWindow: 280,
  focusReveal: 420,
  panToFrame: 520,
  fitView: 760,
  autoFit: 460,
  spaceSwitch: 420,
  restore: 500,
} as const;

export function canvasViewportEase(t: number): number {
  return 1 - (1 - t) ** 3;
}

export function canvasViewportTransition(
  duration: number,
): CanvasViewportTransitionOptions {
  if (duration <= 0 || prefersReducedMotion()) return { duration: 0 };
  return {
    duration,
    ease: canvasViewportEase,
    interpolate: "smooth",
  };
}
